import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  ASYNC_CREATE_ACTION,
  ASYNC_EDIT_ACTION,
  ASYNC_CHANGE_STATUS_ACTION,
} from 'store';
import { useTranslation } from 'react-i18next';
import { registerLocale } from 'react-datepicker';
import {
  Form,
  Row,
  Col,
  Card,
  Tabs,
  Tab,
  Spinner,
  Button,
} from 'react-bootstrap';
import BR from 'date-fns/locale/pt-BR';
import arrayAppend from 'helpers/array-append';
import { api } from 'services';
import { formatDate, parseDate } from 'helpers/date';
import { currencyReverse } from 'helpers/Currency';
import FundTypeEnum from 'enums/FundTypeEnum';
import History from 'components/History';
import MasterPage from 'components/MasterPage';
import Flow from 'components/Flow';
import ComponentType from 'enums/ComponentType';
import ActionStatus from 'enums/ActionStatus';
import { toast } from 'react-toastify';
import ActionsFormFundsExpire from 'components/Actions/Form/FundsExpire';

import ActionFormAction from 'components/Actions/Form/Action';
import ActionsFormExpenseDescriptions from 'components/Actions/Form/ExpenseDescriptions';
import OtherComprovation from 'components/Actions/Form/OtherComprovations';
import ActionsFormRefunds from 'components/Actions/Form/Refunds';
import Invoices from 'components/Actions/Form/Invoices';
import CreativeApproval from './CreativeApproval';
import Dialog from 'react-bootstrap-dialog';
import collect from 'collect.js';
import Can from 'components/Can';

import './style.css';

registerLocale('BR', BR);

const ActionsForm = ({
  createOrEditAction,
  changeStatusAction,
  match: {
    params: { id },
  },
  location,
  loading,
}) => {
  const [name, setName] = useState('');
  const [vendorId, setVendorId] = useState('');
  const [company, setCompany] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [rule, setRule] = useState('');
  const [task, setTask] = useState('');
  const [status, setStatus] = useState('');
  const [event, setEvent] = useState('');
  const [hasAmountTasks, setHasAmountTasks] = useState(false);
  const [amount_tasks, setAmountTasks] = useState('');
  const [taskItems, setTaskItems] = useState([]);
  const [taskItemsIsInternal, setTaskItemsIsInternal] = useState('');
  const [events, setEvents] = useState([]);
  const [description, setDescription] = useState('');

  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [actionExistingFiles, setActionExistingFiles] = useState([]);
  const [filesBriefing, setFilesBriefing] = useState([]);
  const [filesBriefingComments, setFilesBriefingComments] = useState([]);
  const [
    actionExistingFilesBriefing,
    setActionExistingFilesBriefing,
  ] = useState([]);

  const [historyComment, setHistoryComment] = useState('');
  const [funds, setFunds] = useState([]);
  const [fundExtra, setFundExtra] = useState({ value: '' });
  const [periodFunds, setPeriodFunds] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [rules, setRules] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [histories, setHistories] = useState([]);
  const [expenseDescriptions, setExpenseDescriptions] = useState([]);
  const [refunds, setRefunds] = useState([]);
  const [toSteps, setToSteps] = useState([]);
  const [position, setPosition] = useState(0);
  const [eventId, setEventId] = useState('');
  const [valueExpected, setValueExpected] = useState('');
  const [eventscTaskItems] = useState([]);
  const [extra_materials, setExtraMaterials] = useState([]);
  const [deleted_extra_materials, setDeletedExtraMaterials] = useState([]);
  const [atividade, setAtividade] = useState('');
  const [components, setComponents] = useState([]);
  const [planId, setPlanId] = useState(null);
  const [quotaType, setQuotaType] = useState('');
  const [otherComprovations, setOtherComprovations] = useState([]);
  const [artComprovations, setArtComprovations] = useState([]);
  const [fundsExpireModal, showFundsExpireModal] = useState(null);
  const VendorsArr = [];
  const [totalFundsExpireValue, setTotalFundsExpireValue] = useState(0);
  const [event_action, setEventAction] = useState(null);
  const [hasActualValues, setHasActualValues] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [update, setForceUpdate] = useState(false);
  const [statusNow, setStatusNow] = useState(0);

  const [currency, setCurrency] = useState('');
  const [isCreative, setIsCreative] = useState(false);

  const [messageAlert, setMessageAlert] = useState('');
  const [costCenter, setCostCenter] = useState(null);

  const [publico, setPublico] = useState(null);
  const [valor, setValor] = useState(null);
  const [type, setType] = useState(null);

  const [courtesy, setCourtesy] = useState(null);
  const [hasValues, setHasValues] = useState(false);

  const [userCreative, setUserCreative] = useState('');
  const [taskItemsReturnToCreative, setTaskItemsReturnToCreative] = useState([])
  const [materialComplete, setMaterialComplete] = useState(0)

  useEffect(()=>{
    if(atividade === 'evento'){
      setStartDate('');
      setEndDate('');
    } else {
      setPaymentDate('');
      setEventId('');
      setQuotaType('');
    }
  },[atividade]);

  let dialog;
  const { t } = useTranslation();

  const handleChangePeriod = useCallback(
    ({ target: { value } }, funds) => {
      setRule(value);
      setPeriodFunds([]);
      setFunds([]);
      api.get(`funds/list-by-company-rule/${value}`).then(({ data }) => {
        if (data.length !== 0) {
          setFunds(
            data
              .filter((f) => f.type.currency_id === parseInt(currency))
              .map((dt_fund) => {
                let will_return = {
                  fund_id: dt_fund.fund_id,
                  value: 0,
                  fund_type_id: dt_fund.type_id,
                  value_real: dt_fund.value_real ? true : false,
                };
                if (!!funds) {
                  funds.map((fund) => {
                    if (fund.fund_id === dt_fund.id)
                      will_return = {
                        ...will_return,
                        ...{
                          id: fund.id,
                          fund_id: fund.fund_id,
                          value: fund.value,
                          fund_type_id: fund.fund_type_id,
                          value_real: fund.fund.value_real ? true : false,
                        },
                      };
                  });
                }
                return will_return;
              })
          );
        } else {
          if(!courtesy){
            toast.warning(t('error:period without funds'));
          }
        }
        api
          .get(`action-values/list-by-company-rule/${value}`)
          .then((action_values) => {
            let aux = data.filter(
              (f) => f.type.currency_id === parseInt(currency)
            );
            if (aux.length > 0)
              setPeriodFunds(
                aux.map((fund) => {
                  let used = 0;
                  fund.total_funds_expire_value = 0;
                  action_values.data.map((action_value) => {
                    if (action_value.fund_id === fund.id) {
                      fund.total_funds_expire_value +=
                        action_value.total_funds_expire_value ?? 0;
                    }
                  });
                  return { ...fund };
                })
              );
            else {
              setPeriodFunds([]);
              const getMoeda = (currency) => {
                switch (currency) {
                  case '1':
                    return 'Real';
                    break;
                  case '2':
                    return 'Dólar';
                    break;
                  case '3':
                    return 'Euro';
                    break;
                  default:
                    break;
                }
              };
              if (currency !== '')
                if(!courtesy){
                  toast.warning(
                    'O fabricante não possui verba cadastrada em ' +
                      getMoeda(currency)
                  );
                }

            
            }
          });
      });
    },
    [t, currency, courtesy]
  );

  useEffect(() => {
    api.get('companies/all').then(({ data }) => setCompanies(data));
    api.get('get-events').then(({ data }) => setEvents(data));
    api.get('task-groups/list-for-action').then(({ data }) => setTasks(data));
    api
      .get(`get-extra-materials/${id}`)
      .then(({ data }) => setExtraMaterials(data));

    if (id) {
      api.get(`actions/${id}`).then(({ data }) => {
        setHasValues(data.expense_descriptions.length>0)
        if(courtesy==null)setCourtesy(data.all_values.length==0)
        setPublico(data.public);
        setType(data.type);
        setValor(data.value_imp);

        setIsCreative(
          data.task ? (data.task.creative === 1 ? true : false) : false
        );
        setStatusNow(data.status_id);
        setEventAction(data.event_sponsorship);
        handleChangeCompany({ value: data.company_id });
        handleChangePeriod(
          { target: { value: data.company_rule_id } },
          data.all_values
        );
        if (currency === '') {
          setCurrency(data.currency ? data.currency.toString() : '');
        }
        // setIsCreative(data.is_creative);
        setArtComprovations(data.comprovations);
        setValueExpected(data.expected_value);
        setName(data.name);
        setVendorId(data.vendor_id);
        setPlanId(data.marketing_plan_id);
        setCompany(data.company_id);
        setCostCenter(data.company.cost_center ? data.company.cost_center : null);
        data.start_date ? setStartDate(new Date(parseDate(data.start_date))) : setStartDate('');
        data.end_date ? setEndDate(new Date(parseDate(data.end_date))) : setEndDate('');
        setRule(data.company_rule_id);
        setTask(data.task_id ?? '');
        setCurrentStatus(data.status_id);
        setDescription(data.description);
        
        if (data.material_complete){
          setMaterialComplete(data.material_complete)
        }

        setExpenseDescriptions(
          data.expense_descriptions
            .filter((comprovation) => comprovation.service_provider !== null)
            .map((description) => {
              return {
                ...description,
                ...{
                  billet_due_date: description.billet_due_date ? new Date(parseDate(description.billet_due_date)):'',
                  due_date: description.due_date ? new Date(parseDate(description.due_date)):'',
                  issuance_date: description.issuance_date ? new Date(parseDate(description.issuance_date)):'',
                  hidden: true,
                },
              };
            })
        );

        setOtherComprovations(
          data.expense_descriptions
            .filter((comprovation) => comprovation.service_provider === null)
            .map((description) => {
              if (description.value) {
                return {
                  ...description,
                  ...{
                    hidden: true,
                  },
                };
              } else {
                return {
                  ...description,
                };
              }
            })
        );

        setRefunds(
          data.refunds.map((refund) => ({
            ...refund,
            ...{
              receiving_date: new Date(parseDate(refund.receiving_date)),
              hidden: true,
            },
          }))
        );

        setInvoices(
          data.invoices.map((invoice) => ({
            ...invoice,
          }))
        );

        if (data.amount_tasks > 0) {
          setHasAmountTasks(true);
          setAmountTasks(data.amount_tasks);
          if (data.event_sponsorship) {
            setAtividade('evento');
            setEventId(data.event_sponsorship.event_id);
            setTask(data.task_items[0].task_id || '');
            setUserCreative(data.task_items[0].user_id || '');
            setTaskItems(
              data.task_items.map((task_item) => ({
                id: task_item.id,
                description: task_item.description,
                delivery_date: new Date(parseDate(task_item.delivery_date)),
                others: task_item.others_object,
                is_editable: task_item.is_editable
              }))
            );
          } else {
            setAtividade('atividade');
            setTask(data.task_items[0].task_id || '');
            setUserCreative(data.task_items[0].user_id || '');
            setTaskItems(
              data.task_items.map((task_item) => ({
                id: task_item.id,
                description: task_item.description,
                delivery_date: new Date(parseDate(task_item.delivery_date)),
                others: task_item.others_object,
                is_editable: task_item.is_editable,
                briefing: task_item.briefing,
                material_complete: task_item.material_complete,
                enabled_send_arts: task_item.enabled_send_arts,
                briefing: task_item.briefing.map(({ id, name, uri }) => ({ id, name, uri }))[0]
              }))
            );
          }
        } else {
          setAtividade('atividade');
        }

        setTaskItemsIsInternal(
          data.tasks_is_internal !== null ? data.tasks_is_internal : ''
        );

        if (data.event_sponsorship) {
          setAtividade('evento');
          setEventId(data.event_sponsorship.event_id);
          setQuotaType(data.event_sponsorship.quota);
          data.payment_date ? setPaymentDate(new Date(parseDate(data.payment_date))) : setPaymentDate('');
        }

        data.values.forEach((value) => {
          if (value.fund_type_id === FundTypeEnum.extra)
            setFundExtra({ id: value.id, value: value.actual_value });
        });
        setActionExistingFiles(data.files);
        setActionExistingFilesBriefing(data.files_briefing);
        setHistories(data.histories);

        if (!!data.value_extra)
          setFundExtra({
            id: data.value_extra.id,
            fund_id: data.value_extra.fund_id,
            value: data.value_extra.actual_value,
          });

        setTaskItemsReturnToCreative(
          data.task_items.filter(item => item.is_editable == 1).map(item => item.id)
        )
      });
    } else {
      if (currency === '') setCurrency('1');
    }
  }, [id, handleChangePeriod, update]);

  useEffect(() => {
    if (!!location.query && !!location.query.planId) {
      setPlanId(location.query.planId);
      setCompany(location.query.companyId);
      api
        .get(`companies/${location.query.companyId}/available-rules`)
        .then(({ data }) => setRules(data.rules));
      handleChangePeriod({ target: { value: location.query.companyRuleId } });
    }
  }, [location, handleChangePeriod]);

  useEffect(() => {
    if ((currentStatus && id) || (!currentStatus && !id)) {
      api
        .get(
          currentStatus
            ? `flows/${1}/status/${currentStatus}`
            : `flows/${1}/status`
        )
        .then(async ({ data }) => {
          if (data.steps[0]) {
            if (!!data.steps[0].to_steps) {
              if (hasValues) {
                let newSteps = []   
                await Promise.resolve().then(() => {
                  newSteps = data.steps[0].to_steps.filter((s) => {
                    return s.id != 19
                  })                  
                })
                data.steps[0].to_steps = newSteps
              }
              setToSteps(
                filter_event_id(data.steps[0].to_steps, data.steps[0].status_id)
              );
            }
            if (!!data.steps[0].components)
              setComponents(data.steps[0].components);
            if (!!data.steps[0].components) setPosition(data.steps[0].position);
          }
        });
    }
  }, [currentStatus, id, update]);

  const handleChangeCompany = (e) => {
    setCompany(e.value);
    setRule('');
    setPeriodFunds([]);
    setFunds([]);
    setFundExtra([]);
    api
      .get(`companies/${e.value}/available-rules?wt=1`)
      .then(({ data }) => setRules(data.rules));
  };

  const handleChangeCurrency = (value) => {
    setCurrency(value);
    setPeriodFunds([]);
    setFunds([]);
    if (rule) {
      api.get(`funds/list-by-company-rule/${rule}`).then(({ data }) => {
        if (data.length !== 0) {
          setFunds(
            data
              .filter((f) => f.type.currency_id === parseInt(value))
              .map((dt_fund) => {
                let will_return = {
                  fund_id: dt_fund.fund_id,
                  value: 0,
                  fund_type_id: dt_fund.type_id,
                  value_real: dt_fund.value_real ? true : false,
                };
                if (!!funds) {
                  funds.map((fund) => {
                    if (fund.fund_id === dt_fund.id)
                      will_return = {
                        ...will_return,
                        ...{
                          id: fund.id,
                          fund_id: fund.fund_id,
                          value: fund.value,
                          fund_type_id: fund.fund_type_id,
                          value_real: fund.value_real ? true : false,
                        },
                      };
                  });
                }
                return will_return;
              })
          );
        } else {
          if(!courtesy){
            toast.warning(t('error:period without funds'));
            setFunds([]);
          }
        }
        api
          .get(`action-values/list-by-company-rule/${rule}`)
          .then((action_values) => {

            let aux = data.filter(
              (f) => f.type.currency_id === parseInt(value)
            );
            if (aux.length > 0) {
              setPeriodFunds(
                aux.map((fund) => {
                  let used = 0;
                  fund.total_funds_expire_value = 0;
                  action_values.data.map((action_value) => {
                    if (action_value.fund_id === fund.id) {
                      used += action_value.value;
                      fund.total_funds_expire_value +=
                        action_value.total_funds_expire_value ?? 0;
                    }
                  });
                  return { ...fund, ...{ used } };
                })
              );
            } else {
              const getMoeda = (currency) => {
                switch (currency) {
                  case '1':
                    return 'Real';
                    break;
                  case '2':
                    return 'Dólar';
                    break;
                  case '3':
                    return 'Euro';
                    break;
                  default:
                    break;
                }
              };
              if (value !== '') {
                if(!courtesy){
                  toast.warning(
                    'O fabricante não possui verba cadastrada em ' +
                      getMoeda(value)
                  );
                  setPeriodFunds([]);
                }
              }
            }
          });
      });
    }
  };

  const handleUpdateTaskItems = (add) => {
    const updateArray = [...taskItems];

    if (add)
      updateArray.push({
        description: '',
        delivery_date: '',
        others: {},
        is_editable: false,
      });
    else updateArray.pop();

    setTaskItems(updateArray);
  };

  const isDisabled = () => {
    if(statusNow === 9 && artComprovations.filter(a=>a.status_id === 12 || a.status_id === 18).length != amount_tasks){
      return true;
    }
    else if(statusNow === 13 && otherComprovations.length === 0 && !eventId){
      return true;
    }
    else if(statusNow === 13 && expenseDescriptions.filter(a=>a.status_id!==8).length > 0){
      return true;
    }
    return false;
  };

  const handleAddQuantity = () => {
    if (amount_tasks === 50) return;
    setAmountTasks(parseInt(amount_tasks + 1));
    handleUpdateTaskItems(true);
  };

  const handleReduceQuantity = () => {
    if (!amount_tasks || amount_tasks === 1) return;
    setAmountTasks(parseInt(amount_tasks - 1));
    handleUpdateTaskItems(false);
  };

  const handleChangeTask = (e) => {
    setTask(e.target.value);
    tasks.forEach((group) => {
      group.tasks.forEach((task) => {
        if (parseInt(e.target.value) === task.id) {
          setIsCreative(task.creative);
          setHasAmountTasks(task.has_quantity);
          setAmountTasks('');
          setTaskItems([]);
        }
      });
    });
  };

  const handleEventId = (e) => {
    let event_id = e.value;
    setEventId(atividade === 'evento' ? event_id : null);
    // setTask(event_id[1]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    if (id) formData.append('id', id);

    if (!!planId) formData.append('marketing_plan_id', planId);

    formData.append('status_id', status);
    formData.append('name', name);
    formData.append('company_id', company);
    formData.append('expected_value', currencyReverse(valueExpected));
    formData.append('quota', quotaType);
    formData.append('event_id', eventId);
    formData.append('company_rule_id', rule);
    formData.append('task_id', typeof task !== 'undefined' ? task : '');
    formData.append('description', description);
    formData.append('history_comment', historyComment);
    formData.append('start_date', startDate ? formatDate(startDate) : '');
    formData.append('end_date', endDate ? formatDate(endDate) : '');
    formData.append('payment_date', paymentDate ? formatDate(paymentDate) : '');
    formData.append('currency', currency);
    formData.append('message_alert', messageAlert);

    const extraMat = [];

    extra_materials.forEach((extra) =>
      extraMat.push({
        ...extra,
        ...{ value: currencyReverse(extra.value) },
      })
    );

    const cFunds = [];

    if(!courtesy){
      funds.forEach((fund) => {
        if (!!fund.value > 0) {
          if (!fund.value_real && (!status || status != ActionStatus.Draft)) {
            toast.error('Verbas sem valor real');
            return;
          } else
            cFunds.push({ ...fund, ...{ value: currencyReverse(fund.value) } });
        }
      });
      formData.append('courtesy', 0);
    } else {
      formData.append('courtesy', 1);
    }

    arrayAppend(formData, 'funds', cFunds);
    if (!!fundExtra.value)
      arrayAppend(formData, 'fund_extra', {
        ...fundExtra,
        ...{ value: currencyReverse(fundExtra.value) },
      });
    arrayAppend(formData, 'file', files);
    arrayAppend(formData, 'files_comments', filesComments);
    if (hasAmountTasks) {
      arrayAppend(formData, 'file_briefing', filesBriefing);
      arrayAppend(formData, 'files_briefing_comments', filesBriefingComments);
    }

    const cTaskItems = taskItems.map((item) => ({
      ...item,
      ...{ delivery_date: formatDate(item.delivery_date) },
      ...{ is_internal: taskItemsIsInternal },
      ...{ user_id: userCreative},
      ...{ others: JSON.stringify(item.others) },
      ...{ is_editable: 0 },
    }));
    arrayAppend(formData, 'task_items', cTaskItems);

    if (hasAmountTasks) {
      formData.append('amount_tasks', amount_tasks);
      formData.append('material_complete', materialComplete);
    }

    arrayAppend(formData, 'extra_materials', extraMat);

    if (!eventId && atividade == 'evento') {
      toast.error('O Campo Evento é Obrigatório');
      return;
    }

    formData.append('public', publico);
    formData.append('value_imp', valor);
    formData.append('type', type);

    createOrEditAction(formData);
  };

  const buildFormStatus = () => {
    const formData = new FormData();

    formData.append('action_id', id);
    formData.append('current_status', currentStatus);
    formData.append('to_status', status);
    formData.append('history_comment', historyComment);
    formData.append('payment_date', paymentDate ? formatDate(paymentDate) : '');
    
    if (currentStatus == ActionStatus.AwaitingArts || currentStatus == ActionStatus.BriefingRefused) {
      arrayAppend(formData, 'file_briefing', filesBriefing);
      arrayAppend(formData, 'files_briefing_comments', filesBriefingComments);
      arrayAppend(formData, 'return_to_creative', taskItemsReturnToCreative)
    }

    if (courtesy && currentStatus == ActionStatus.OnExecution) {
      formData.append('is_courtesy', 1)
    }

    if (collect(taskItems).where('is_editable', true).count() > 0) {
      const cTaskItems = taskItems.map((item) => ({
        ...item,
        ...{ delivery_date: formatDate(item.delivery_date) },
        ...{ is_internal: taskItemsIsInternal },
        ...{ others: JSON.stringify(item.others) },
        ...{ is_editable: 0 }
      }));
      arrayAppend(formData, 'task_items', cTaskItems);
      formData.append('amount_tasks', amount_tasks);
      formData.append('task_id', typeof task !== 'undefined' ? task : '');
    }
    formData.append('message_alert', messageAlert);

    if (vendorId) formData.append('vendor_id', vendorId);

    return formData;
  };

  const confirmation = () => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          let formData = buildFormStatus();
          changeStatusAction(formData);
        }),
      ],
      bgSize: 'small',
    });
  };

  const handleChangeStatus = (e) => {
    if (e) e.preventDefault();

    if (
      status === ActionStatus.ComprovationsApproval &&
      expenseDescriptions.length >= 1 &&
      calculateExpenseValue() > 0
    ) {
      showFundsExpireModal(true);
      return;
    }

    if (
      currentStatus === ActionStatus.AwaitingReceipt &&
      refunds.length === 0
    ) {
      toast.error(t('error:The refunds are required.'), { autoClose: 10000 });
      return;
    }

    confirmation();
  };

  const calculateExpenseValue = () => {
    var sum = 0;

    funds.forEach(
      (fund) =>
        (sum += !!currencyReverse(fund.value)
          ? currencyReverse(fund.value)
          : 0)
    );
    expenseDescriptions.filter((expense)=>{
      return expense.status_id != 7;
    }).forEach(
      (expense) => (sum -= expense.value / expense.value_cotacao)
    );

    return sum;
  };

  const objComponents = {
    [ComponentType.Action]: (key, props) => (
      <Tab eventKey="action" title={t('title:action')} key={key}>
        {React.createElement(ActionFormAction, {
          ...{
            key,
            event,
            setEvent,
            planId,
            actionId: id,
            position,
            name,
            setName,
            company,
            setVendorId,
            vendorId,
            setCompany,
            startDate,
            setStartDate,
            endDate,
            setEndDate,
            paymentDate,
            setPaymentDate,
            rule,
            setRule,
            events,
            setEvents,
            task,
            setTask,
            hasAmountTasks,
            amount_tasks,
            setAmountTasks,
            taskItems,
            setTaskItems,
            taskItemsIsInternal,
            setTaskItemsIsInternal,
            description,
            setDescription,
            files,
            setFiles,
            filesBriefing,
            setFilesBriefing,
            filesComments,
            setFilesComments,
            filesBriefingComments,
            setFilesBriefingComments,
            actionExistingFiles,
            actionExistingFilesBriefing,
            funds,
            setFunds,
            fundExtra,
            setFundExtra,
            companies,
            rules,
            tasks,
            periodFunds,
            handleChangeCompany,
            handleChangePeriod,
            handleAddQuantity,
            handleReduceQuantity,
            handleChangeTask,
            eventId,
            setEventId,
            handleEventId,
            extra_materials,
            setExtraMaterials,
            deleted_extra_materials,
            setDeletedExtraMaterials,
            setAtividade,
            atividade,
            valueExpected,
            setValueExpected,
            quotaType,
            setQuotaType,
            VendorsArr,
            currentStatus,
            expenseDescriptions,
            totalFundsExpireValue,
            setTotalFundsExpireValue,
            calculateExpenseValue,
            currency,
            handleChangeCurrency,
            statusNow,
            isCreative,
            valor, setValor,
            publico, setPublico,
            type, setType,
            courtesy, setCourtesy,
            userCreative, setUserCreative,
            materialComplete, setMaterialComplete,
            artComprovations
          },
          ...props,
        })}
      </Tab>
    ),

    [ComponentType.ExpenseDescriptions]: (key, props) => (
      !eventId ? 
        (
          <Tab
            eventKey="expensedescriptions"
            title={t('title:description amount')}
            key={key}
          >
            {React.createElement(ActionsFormExpenseDescriptions, {
              ...{
                key,
                actionId: id,
                expenseDescriptions,
                setExpenseDescriptions,
                location: location.search,
                maxValue: calculateExpenseValue(),
                periodFunds: periodFunds,
                currency: currency,
                funds: funds,
                costCenterObj: costCenter,
                courtesy,
                setHasValues,
                toSteps,
                setToSteps
              },
              ...props,
            })}
          </Tab>
        )
      : null
    ),
    [ComponentType.OtherComprovations]: (key, props) => {
      return (
        <Tab
          eventKey="othercomprovations"
          title={t('title:other comprovations')}
          key={key}
        >
          {React.createElement(OtherComprovation, {
            ...{
              key,
              actionId: id,
              otherComprovations,
              setOtherComprovations,
              maxValue: (() => {
                var sum = 0;

                funds.forEach(
                  (fund) =>
                    (sum += !!currencyReverse(String(fund.value))
                      ? currencyReverse(String(fund.value))
                      : 0)
                );
                sum += !!currencyReverse(String(fundExtra.value))
                  ? currencyReverse(String(fundExtra.value))
                  : 0;
                otherComprovations.forEach((expense) => (sum -= expense.value));

                return sum;
              })(),
              periodFunds: periodFunds,
              currency: currency,
              funds: funds,
            },
            ...props,
          })}
        </Tab>
      );
    },
    [ComponentType.Refunds]: (key, props) => (
      <Tab eventKey="refunds" title={t('title:refund information')} key={key}>
        {React.createElement(ActionsFormRefunds, {
          ...{ key, actionId: id, refunds, setRefunds, currency: currency },
          ...props,
        })}
      </Tab>
    ),

    [ComponentType.Comprovation]: (key, props) => {
      return hasAmountTasks ? (
        <Tab eventKey="creative" title={t('title:creative approval')} key={key}>
          {React.createElement(CreativeApproval, {
            ...{ key, actionId: id, forceUpdate: setForceUpdate },
            ...props,
          })}
        </Tab>
      ) : null;
    },
    [ComponentType.Invoice]: (key, props) => {
      return (
        <Tab eventKey="invoice" title={t('title:invoices')} key={key}>
          {React.createElement(Invoices, {
            ...{ key, actionId: id, actionName: name },
            invoices,
            setInvoices,
            ...props,
          })}
        </Tab>
      );
    },
  };

  const filter_event_id = (toSteps, status_id) => {
    if (event_action != null && event_action.event_id != null) {
      toSteps = toSteps.map((step) => {
        // if (step.id == 21 && status_id == 22 && !isCreative)
        //   return { id: 17, name: 'awaiting_receipt', color: '#a9a5a5' };
        // if (step.id == 21 && status_id == 9)
        //   return { id: 17, name: 'awaiting_receipt', color: '#a9a5a5' };
        return step;
      });
    }
    return toSteps;
  };

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Form
        onSubmit={
          currentStatus !== ActionStatus.Disapproved &&
          currentStatus !== ActionStatus.Draft &&
          id
            ? handleChangeStatus
            : handleSubmit
        }
      >
        <Card.Body className="shadow bg-white rounded mb-3">
          <Tabs
            defaultActiveKey="action"
            id="uncontrolled-tab-example"
            className="mb-3"
            mountOnEnter
          >
            {components.map((component, k) =>
              objComponents[component.component_type_id](k, {
                editable: component.editable,
              })
            )}
          </Tabs>
          <Row>
            <Col xs={12} md={12} className="mt-2">
              <Form.Group>
                <Form.Label>{t('label:additional information')}</Form.Label>
                <Form.Control
                  as="textarea"
                  value={historyComment}
                  onChange={(e) => setHistoryComment(e.target.value)}
                  rows="4"
                />
              </Form.Group>
              {id && currentStatus !== 9 && !loading ? (
                isCreative ? (<>                  
                  <Can do="cancelActionWithoutDraftStatus" on="App">
                    {currentStatus == 25 && toSteps.length > 0? (
                      <Button
                        size="md"
                        variant="primary-login"
                        type="submit"
                        className="login-btn mr-2 mt-5"
                        onClick={() => {
                          setStatus(histories[1].status_id)
                          setMessageAlert('Solicitação de cancelamento reprovado!');
                        }}
                      >
                        Reprovar Cancelamento
                      </Button>
                    ) : (<></>)}
                  </Can>
                  
                  <Can do={`${currentStatus}`} on="App">
                    <Flow
                      toSteps={toSteps}
                      setStatus={setStatus}
                      disabled={isDisabled()}
                      currentStatus={currentStatus}
                      notShow={{
                        [ActionStatus.OnExecution]: !!id,
                      }}
                      setMessageAlert={setMessageAlert}
                    />
                  </Can>
                </> ) : (<>
                  <Can do="cancelActionWithoutDraftStatus" on="App">
                    {currentStatus == 25 && toSteps.length > 0? (
                      <Button
                        size="md"
                        variant="primary-login"
                        type="submit"
                        className="login-btn mr-2 mt-5"
                        onClick={() => {
                          setStatus(histories[1].status_id)
                          setMessageAlert('Solicitação de cancelamento reprovado!');
                        }}
                      >
                        Reprovar Cancelamento
                      </Button>
                    ) : (<></>)}
                  </Can>

                  <Can do={`${currentStatus}`} on="App">
                    <Flow
                      toSteps={toSteps}
                      setStatus={setStatus}
                      disabled={isDisabled()}
                      currentStatus={currentStatus}
                      notShow={{
                        [ActionStatus.AwaitingArts]: !!id,
                        [ActionStatus.AwaitingArts]: currentStatus !== 9,
                      }}
                      setMessageAlert={setMessageAlert}
                    />
                  </Can>
                </>)
              ) : !loading ? (
                <>
                  {/* {currentStatus ? (
                    <Button
                      size="md"
                      variant="primary-login"
                      type="submit"
                      className="login-btn mr-2 mt-5"
                      onClick={() => setStatus(statusNow)}
                    >
                      {t(`flow:draft`)}
                    </Button>
                  ) : (<></>)} */}
                  <Flow
                    toSteps={toSteps}
                    setStatus={setStatus}
                    disabled={isDisabled()}
                    currentStatus={currentStatus}
                    setMessageAlert={setMessageAlert}
                  />
                  
                  {/* {collect(taskItems).where('is_editable', true).count() > 0 ? ( */}
                    <Button
                      size="md"
                      variant="primary-login"
                      type="submit"
                      className="login-btn mr-2 mt-5"
                      onClick={() => setStatus(statusNow)}
                    >
                      Salvar
                    </Button>
                  {/* ) : (
                    (<></>)
                  )} */}
                </>
              ) : (
                <>
                  <Row className="float-left text-left">
                    <Spinner animation="border" style={{ color: '#e05c17' }} />
                    <h6 className="m-2">Salvando...</h6>
                  </Row>
                </>
              )}

              <History histories={histories} />
            </Col>
          </Row>
        </Card.Body>
        <ActionsFormFundsExpire
          {...{
            fundsExpireModal,
            showFundsExpireModal,
            handleChangeStatus,
            buildFormStatus,
            changeStatusAction,
            calculateExpenseValue,
            funds,
          }}
        ></ActionsFormFundsExpire>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = (dispatch) => ({
  createOrEditAction: (payload) => {
    if (payload.has('id')) {
      dispatch({ type: ASYNC_EDIT_ACTION, payload });
    } else {
      dispatch({ type: ASYNC_CREATE_ACTION, payload });
    }
  },
  changeStatusAction: (payload) => {
    dispatch({ type: ASYNC_CHANGE_STATUS_ACTION, payload });
  },
});

const connectRedux = connect(mapStateToProps, mapDispatchToProps)(ActionsForm);

export default MasterPage(connectRedux);
